export enum ButtonSize {
    XXSmall = 'xx-small',
    XSmall = 'x-small',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'x-large',
}
